import React from 'react';

import { CognitoProviderContext } from 'src/providers/CognitoProvider';

export const useCognito = () => {
  return React.use(CognitoProviderContext);
};
